export default () => ({
    currentStepIndex: null,
    started: false,
    paused: false,
    transcriptPlaying: false,
    transcriptFinished: false,
});
